import firebase from 'firebase/app'
import { useEmulator } from '../config'
import { v4 as uuidv4 } from 'uuid'

const db = firebase.firestore()

if (useEmulator) {
  db.useEmulator('localhost', 5005)
}

function getUserRef(userId) {
  return db.collection('users')
    .doc(userId)
}

export function getAll(userId) {
  return getUserRef(userId)
    .get()
    .then((snapshot) => {
      if (!snapshot.exists) {
        return []
      }
      return snapshot.data().categories
    })
    .catch(err => console.error(err))
}

export function save(category, userId) {
  const userRef = getUserRef(userId)
  const { id } = category

  return userRef.update({
    categories: firebase.firestore.FieldValue.arrayUnion({
      ...category,
      id: !id ? uuidv4() : id
    })
  })
}

export function remove(category, userId) {
  const userRef = getUserRef(userId)

  return userRef.update({
    categories: firebase.firestore.FieldValue.arrayRemove(category)
  })
}

export function getById(categoryId, userId) {
  return getAll(userId)
    .then(categories => categories.find(({ id }) => id === categoryId))
}

export function getByName(categoryName, userId) {
  return getAll(userId)
    .then(categories => categories.find(({ name }) => name === categoryName))
}
